import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const FlashcardCollectionService = sdk.getService('FlashcardCollectionService');

export const useMyAllFlashcardsCollectionListForSelector = (courseId?: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ['flashcards', 'flashcards-collection', 'all', courseId],
    queryFn: () => FlashcardCollectionService.getAllFlashcardCollectionsByCourseId(courseId)
  });

  return { data, isLoading };
};
